import { render, staticRenderFns } from "./PaymentAccountsList.vue?vue&type=template&id=1f18b96f&scoped=true&"
import script from "./PaymentAccountsList.vue?vue&type=script&lang=js&"
export * from "./PaymentAccountsList.vue?vue&type=script&lang=js&"
import style0 from "./PaymentAccountsList.vue?vue&type=style&index=0&id=1f18b96f&lang=scss&scoped=true&"
import style1 from "./PaymentAccountsList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f18b96f",
  null
  
)

export default component.exports